class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    // this.setHeaderCartIconAccessibility();

    document.querySelectorAll("[data-open-cart-drawer]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(button);
      });
    });
  }

  removeTrapFocus(elementToFocus = null) {
    // document.removeEventListener("focusin", trapFocusHandlers.focusin);
    // document.removeEventListener("focusout", trapFocusHandlers.focusout);
    // document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
  }

  setHeaderCartIconAccessibility() {
    // const cartLink = document.querySelector("#cart-icon-bubble");
    const cartLinks = document.querySelectorAll("a.mini_cart");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (window.location.href.includes("/cart")) {
      window.location.href = "/cart";
      return;
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    // this.addEventListener(
    //   "transitionend",
    //   () => {
    //     // const containerToTrapFocusOn = this.classList.contains("is-empty")
    //     //   ? this.querySelector(".drawer__inner-empty")
    //     //   : document.getElementById("CartDrawer");
    //     // const focusElement =
    //     //   this.querySelector(".drawer__inner") ||
    //     //   this.querySelector(".drawer__close");
    //     // trapFocus(containerToTrapFocusOn, focusElement);
    //   },
    //   { once: true }
    // );

    document.body.classList.add("overflow-hidden");
    // document.body.classList.add("blocked-scroll");
  }

  close() {
    this.classList.remove("active");
    this.removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    const isCartPage = window.location.href.includes("/cart");
    if (isCartPage) {
      fetch("/cart?section_id=cart-template")
        .then((res) => res.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, "text/html");
          const newCartTemplate = html.querySelector(
            "#shopify-section-cart-template",
          );
          const itemsToUpdate = [
            ".cart-template__items-wrapper",
            ".shopify-section--cart-template .js-cart_savings",
            ".shopify-section--cart-template .js-cart_subtotal",
          ];
          itemsToUpdate.forEach(
            (item) =>
              (document.querySelector(item).innerHTML =
                newCartTemplate.querySelector(item).innerHTML),
          );
        });
    } else {
      fetch("/?section_id=cart-drawer")
        .then((res) => res.text())
        .then((data) => {
          const html = new DOMParser().parseFromString(data, "text/html");
          const newCartDrawer = html.querySelector("cart-drawer");
          const currentCartDrawer = document.querySelector("cart-drawer");

          currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

          const cartItemCount = newCartDrawer.querySelector(
            "[data-cart-item-count]",
          );

          if (cartItemCount) {
            document.querySelectorAll(".cart_count").forEach((cartCount) => {
              cartCount.innerHTML = cartItemCount.innerHTML;
            });
          } else {
            document.querySelectorAll(".cart_count").forEach((cartCount) => {
              cartCount.innerHTML = 0;
            });
          }

          window.featuredCollection.initSection(
            document.querySelector(
              "cart-drawer .js-product-slider .products-slider",
            ),
          );

          this.querySelector("#CartDrawer-Overlay").addEventListener(
            "click",
            this.close.bind(this),
          );

          if (newCartDrawer.classList.contains("is-empty")) {
            currentCartDrawer.classList.add("is-empty");
          } else {
            currentCartDrawer.classList.remove("is-empty");
          }

          if (!isCartPage && !currentCartDrawer.classList.contains("active"))
            this.open();

          document.dispatchEvent(
            new CustomEvent("init:cart-drawer-thumbs", {
              detail: {
                thumbnails: document.querySelectorAll(
                  "cart-drawer .js-product-slider .thumbnail",
                ),
              },
            }),
          );

          // document.dispatchEvent(new CustomEvent("cart-drawer:update", {}));
        });
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
